/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInjectionMapDto,
  InjectionMapDraftResponse,
  InjectionMapResponse,
  InjectionMapTemplateResponse,
  InjectionMapsLastParams,
  InjectionMapsListParams,
  InjectionMapsListTemplatesParams,
  ReuseInjectionMapDto,
  SaveInjectionTemplateDto,
  UpdateInjectionMapDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * مختصات هر نقطه کسری از ابعاد تصویر نقشه است (۰ تا ۱) تا رندر مستقل از اندازه باشد. مجموع دوز از روی نقاط محاسبه می‌شود و هرگز از بدنهٔ درخواست خوانده نمی‌شود.
 * @summary ثبت نقشهٔ تزریق
 */
export const injectionMapsCreate = (
    createInjectionMapDto: CreateInjectionMapDto,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapResponse>(
      {url: `/api/v1/injection-maps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInjectionMapDto, signal
    },
      );
    }




export const getInjectionMapsCreateMutationKey = () => ['injectionMapsCreate'] as const;

export const getInjectionMapsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsCreate>>, TError,InjectionMapsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsCreate>>, TError,InjectionMapsCreateMutationVariables, TContext> => {

const mutationKey = getInjectionMapsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsCreate>>, InjectionMapsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  injectionMapsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsCreate>>>
    export type InjectionMapsCreateMutationBody = CreateInjectionMapDto
    export type InjectionMapsCreateMutationError = void
    export type InjectionMapsCreateMutationVariables = {data: CreateInjectionMapDto}

    /**
 * @summary ثبت نقشهٔ تزریق
 */
export const useInjectionMapsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsCreate>>, TError,InjectionMapsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsCreate>>,
        TError,
        InjectionMapsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsCreateMutationOptions(options), queryClient);
    }
    /**
 * @summary فهرست نقشه‌های تزریق
 */
export const injectionMapsList = (
    params?: InjectionMapsListParams,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapResponse[]>(
      {url: `/api/v1/injection-maps`, method: 'GET',
        params, signal
    },
      );
    }




export const getInjectionMapsListQueryKey = (params?: InjectionMapsListParams,) => {
    return [
    `/api/v1/injection-maps`, ...(params ? [params] : [])
    ] as const;
    }


export const getInjectionMapsListQueryOptions = <TData = Awaited<ReturnType<typeof injectionMapsList>>, TError = unknown>(params?: InjectionMapsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInjectionMapsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof injectionMapsList>>> = ({ signal }) => injectionMapsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InjectionMapsListQueryResult = NonNullable<Awaited<ReturnType<typeof injectionMapsList>>>
export type InjectionMapsListQueryError = unknown


export function useInjectionMapsList<TData = Awaited<ReturnType<typeof injectionMapsList>>, TError = unknown>(
 params: undefined |  InjectionMapsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsList>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsList<TData = Awaited<ReturnType<typeof injectionMapsList>>, TError = unknown>(
 params?: InjectionMapsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsList>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsList<TData = Awaited<ReturnType<typeof injectionMapsList>>, TError = unknown>(
 params?: InjectionMapsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست نقشه‌های تزریق
 */

export function useInjectionMapsList<TData = Awaited<ReturnType<typeof injectionMapsList>>, TError = unknown>(
 params?: InjectionMapsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInjectionMapsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای پیش‌پر کردن مراجعهٔ بعدی. چیزی ثبت نمی‌شود و یادداشت اختصاصی مراجعهٔ قبلی عمداً منتقل نمی‌شود، چون آن یادداشت مشاهدهٔ همان جلسه بوده است. اگر بیمار نقشهٔ قبلی نداشته باشد پاسخ null است.
 * @summary آخرین نقشهٔ این بیمار، به‌صورت پیش‌نویس
 */
export const injectionMapsLast = (
    params: InjectionMapsLastParams,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapDraftResponse | null>(
      {url: `/api/v1/injection-maps/last`, method: 'GET',
        params, signal
    },
      );
    }




export const getInjectionMapsLastQueryKey = (params?: InjectionMapsLastParams,) => {
    return [
    `/api/v1/injection-maps/last`, ...(params ? [params] : [])
    ] as const;
    }


export const getInjectionMapsLastQueryOptions = <TData = Awaited<ReturnType<typeof injectionMapsLast>>, TError = unknown>(params: InjectionMapsLastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInjectionMapsLastQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof injectionMapsLast>>> = ({ signal }) => injectionMapsLast(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InjectionMapsLastQueryResult = NonNullable<Awaited<ReturnType<typeof injectionMapsLast>>>
export type InjectionMapsLastQueryError = unknown


export function useInjectionMapsLast<TData = Awaited<ReturnType<typeof injectionMapsLast>>, TError = unknown>(
 params: InjectionMapsLastParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsLast>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsLast>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsLast<TData = Awaited<ReturnType<typeof injectionMapsLast>>, TError = unknown>(
 params: InjectionMapsLastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsLast>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsLast>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsLast<TData = Awaited<ReturnType<typeof injectionMapsLast>>, TError = unknown>(
 params: InjectionMapsLastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary آخرین نقشهٔ این بیمار، به‌صورت پیش‌نویس
 */

export function useInjectionMapsLast<TData = Awaited<ReturnType<typeof injectionMapsLast>>, TError = unknown>(
 params: InjectionMapsLastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsLast>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInjectionMapsLastQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * با persist=false فقط پیش‌نویس برمی‌گردد و چیزی ثبت نمی‌شود؛ با persist=true نقشهٔ جدید بلافاصله برای جلسهٔ داده‌شده ذخیره می‌شود.
 * @summary استفادهٔ دوباره از نقشهٔ قبلی
 */
export const injectionMapsReuseLast = (
    reuseInjectionMapDto: ReuseInjectionMapDto,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapDraftResponse>(
      {url: `/api/v1/injection-maps/reuse-last`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reuseInjectionMapDto, signal
    },
      );
    }




export const getInjectionMapsReuseLastMutationKey = () => ['injectionMapsReuseLast'] as const;

export const getInjectionMapsReuseLastMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsReuseLast>>, TError,InjectionMapsReuseLastMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsReuseLast>>, TError,InjectionMapsReuseLastMutationVariables, TContext> => {

const mutationKey = getInjectionMapsReuseLastMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsReuseLast>>, InjectionMapsReuseLastMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  injectionMapsReuseLast(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsReuseLastMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsReuseLast>>>
    export type InjectionMapsReuseLastMutationBody = ReuseInjectionMapDto
    export type InjectionMapsReuseLastMutationError = void
    export type InjectionMapsReuseLastMutationVariables = {data: ReuseInjectionMapDto}

    /**
 * @summary استفادهٔ دوباره از نقشهٔ قبلی
 */
export const useInjectionMapsReuseLast = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsReuseLast>>, TError,InjectionMapsReuseLastMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsReuseLast>>,
        TError,
        InjectionMapsReuseLastMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsReuseLastMutationOptions(options), queryClient);
    }
    /**
 * پروتکل‌های ثابت کلینیک؛ بدون هیچ اطلاعاتی از بیماران.
 * @summary فهرست الگوهای تزریق کلینیک
 */
export const injectionMapsListTemplates = (
    params?: InjectionMapsListTemplatesParams,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapTemplateResponse[]>(
      {url: `/api/v1/injection-maps/templates`, method: 'GET',
        params, signal
    },
      );
    }




export const getInjectionMapsListTemplatesQueryKey = (params?: InjectionMapsListTemplatesParams,) => {
    return [
    `/api/v1/injection-maps/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getInjectionMapsListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError = unknown>(params?: InjectionMapsListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInjectionMapsListTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof injectionMapsListTemplates>>> = ({ signal }) => injectionMapsListTemplates(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InjectionMapsListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof injectionMapsListTemplates>>>
export type InjectionMapsListTemplatesQueryError = unknown


export function useInjectionMapsListTemplates<TData = Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError = unknown>(
 params: undefined |  InjectionMapsListTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsListTemplates>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsListTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsListTemplates<TData = Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError = unknown>(
 params?: InjectionMapsListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsListTemplates>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsListTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsListTemplates<TData = Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError = unknown>(
 params?: InjectionMapsListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست الگوهای تزریق کلینیک
 */

export function useInjectionMapsListTemplates<TData = Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError = unknown>(
 params?: InjectionMapsListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsListTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInjectionMapsListTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary جزئیات یک نقشهٔ تزریق
 */
export const injectionMapsById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapResponse>(
      {url: `/api/v1/injection-maps/${id}`, method: 'GET', signal
    },
      );
    }




export const getInjectionMapsByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/injection-maps/${id}`
    ] as const;
    }


export const getInjectionMapsByIdQueryOptions = <TData = Awaited<ReturnType<typeof injectionMapsById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInjectionMapsByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof injectionMapsById>>> = ({ signal }) => injectionMapsById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InjectionMapsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof injectionMapsById>>>
export type InjectionMapsByIdQueryError = void


export function useInjectionMapsById<TData = Awaited<ReturnType<typeof injectionMapsById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsById>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsById<TData = Awaited<ReturnType<typeof injectionMapsById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof injectionMapsById>>,
          TError,
          Awaited<ReturnType<typeof injectionMapsById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInjectionMapsById<TData = Awaited<ReturnType<typeof injectionMapsById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک نقشهٔ تزریق
 */

export function useInjectionMapsById<TData = Awaited<ReturnType<typeof injectionMapsById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof injectionMapsById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInjectionMapsByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary ویرایش نقشهٔ تزریق
 */
export const injectionMapsUpdate = (
    id: string,
    updateInjectionMapDto: UpdateInjectionMapDto,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapResponse>(
      {url: `/api/v1/injection-maps/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateInjectionMapDto, signal
    },
      );
    }




export const getInjectionMapsUpdateMutationKey = () => ['injectionMapsUpdate'] as const;

export const getInjectionMapsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsUpdate>>, TError,InjectionMapsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsUpdate>>, TError,InjectionMapsUpdateMutationVariables, TContext> => {

const mutationKey = getInjectionMapsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsUpdate>>, InjectionMapsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  injectionMapsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsUpdate>>>
    export type InjectionMapsUpdateMutationBody = UpdateInjectionMapDto
    export type InjectionMapsUpdateMutationError = unknown
    export type InjectionMapsUpdateMutationVariables = {id: string;data: UpdateInjectionMapDto}

    /**
 * @summary ویرایش نقشهٔ تزریق
 */
export const useInjectionMapsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsUpdate>>, TError,InjectionMapsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsUpdate>>,
        TError,
        InjectionMapsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsUpdateMutationOptions(options), queryClient);
    }
    /**
 * @summary حذف نرم نقشهٔ تزریق
 */
export const injectionMapsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/injection-maps/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getInjectionMapsRemoveMutationKey = () => ['injectionMapsRemove'] as const;

export const getInjectionMapsRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsRemove>>, TError,InjectionMapsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsRemove>>, TError,InjectionMapsRemoveMutationVariables, TContext> => {

const mutationKey = getInjectionMapsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsRemove>>, InjectionMapsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  injectionMapsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsRemove>>>

    export type InjectionMapsRemoveMutationError = unknown
    export type InjectionMapsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف نرم نقشهٔ تزریق
 */
export const useInjectionMapsRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsRemove>>, TError,InjectionMapsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsRemove>>,
        TError,
        InjectionMapsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsRemoveMutationOptions(options), queryClient);
    }
    /**
 * نقاط و دوزها منتقل می‌شوند اما بیمار و یادداشت‌ها نه — الگو یک پروتکل مشترک است و نباید دادهٔ بالینی یک نفر را در خود داشته باشد.
 * @summary ذخیرهٔ نقشه به‌عنوان الگوی کلینیک
 */
export const injectionMapsSaveAsTemplate = (
    id: string,
    saveInjectionTemplateDto: SaveInjectionTemplateDto,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapTemplateResponse>(
      {url: `/api/v1/injection-maps/${id}/save-as-template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveInjectionTemplateDto, signal
    },
      );
    }




export const getInjectionMapsSaveAsTemplateMutationKey = () => ['injectionMapsSaveAsTemplate'] as const;

export const getInjectionMapsSaveAsTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>, TError,InjectionMapsSaveAsTemplateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>, TError,InjectionMapsSaveAsTemplateMutationVariables, TContext> => {

const mutationKey = getInjectionMapsSaveAsTemplateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>, InjectionMapsSaveAsTemplateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  injectionMapsSaveAsTemplate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsSaveAsTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>>
    export type InjectionMapsSaveAsTemplateMutationBody = SaveInjectionTemplateDto
    export type InjectionMapsSaveAsTemplateMutationError = unknown
    export type InjectionMapsSaveAsTemplateMutationVariables = {id: string;data: SaveInjectionTemplateDto}

    /**
 * @summary ذخیرهٔ نقشه به‌عنوان الگوی کلینیک
 */
export const useInjectionMapsSaveAsTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>, TError,InjectionMapsSaveAsTemplateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsSaveAsTemplate>>,
        TError,
        InjectionMapsSaveAsTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsSaveAsTemplateMutationOptions(options), queryClient);
    }
    /**
 * الگو حذف نمی‌شود تا نقشه‌هایی که به آن ارجاع دارند مرجع خود را از دست ندهند.
 * @summary غیرفعال کردن الگو
 */
export const injectionMapsDeactivateTemplate = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<InjectionMapTemplateResponse>(
      {url: `/api/v1/injection-maps/templates/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getInjectionMapsDeactivateTemplateMutationKey = () => ['injectionMapsDeactivateTemplate'] as const;

export const getInjectionMapsDeactivateTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>, TError,InjectionMapsDeactivateTemplateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>, TError,InjectionMapsDeactivateTemplateMutationVariables, TContext> => {

const mutationKey = getInjectionMapsDeactivateTemplateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>, InjectionMapsDeactivateTemplateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  injectionMapsDeactivateTemplate(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InjectionMapsDeactivateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>>

    export type InjectionMapsDeactivateTemplateMutationError = unknown
    export type InjectionMapsDeactivateTemplateMutationVariables = {id: string}

    /**
 * @summary غیرفعال کردن الگو
 */
export const useInjectionMapsDeactivateTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>, TError,InjectionMapsDeactivateTemplateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof injectionMapsDeactivateTemplate>>,
        TError,
        InjectionMapsDeactivateTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getInjectionMapsDeactivateTemplateMutationOptions(options), queryClient);
    }
